import React, { Component } from 'react';
import { connect } from 'dva';
import router from 'umi/router';
import moment from "moment";
import { Button, Form, Tabs, Spin, Icon, Upload, message, Modal, Checkbox } from 'antd';
import FormCreate from '../../../../../components/FormCreate/index';
import Container from '../../../../../components/Container';
import { url as api } from '../../services/service-utils';
import { GetQueryString, getAppCode } from '../../utils/utils';
import { convertData, getDefaultData } from '../../utils/convertData';
import SelectTagModal from '../../components/SelectTag'
import { kindergartenClass, primarySchoolClass, middleSchoolClass, allIdList } from '../utils/classData';
import styles from './index.less';
import CourseContentModal from './components/CourseContent';
import PublishModal from './components/PublishModal';

const { TabPane } = Tabs;
const { Item } = Form;
const {
  FormTitle,
  FormCascader,
  FormRadioGroup,
  SelectUserVersion4,
  FormCheckbox,
} = FormCreate;


@Form.create()

@connect(({ createIndependentCourse, user, courseManage }) => ({
  ...createIndependentCourse,
  currentUser: user.currentUser,
  ...courseManage,
}))
class Edit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      previewImage: '',
      previewVisible: false,
      spinning: false,
      channelList: [],
      activeKey: '1',
      checkAll: false,
      checkedValue: [],
      groupData: []
    };
    this.newsId = GetQueryString('id') || '';
  }

  componentDidMount() {
    const { dispatch } = this.props;
    this.fetchChannelList();
    if (!this.newsId) {
      dispatch({
        type: 'courseManage/fetchLabelWithGroup',
        params: { appCode: getAppCode() },
      }).then(res => {
        this.setState({
          checkedValue: [],
          groupData: res,
        });
      });
    }
  }


  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch({
      type: 'createIndependentCourse/reset',
    });
  }

  handleSaveLabelOk = data => {
    const { checkedValue, groupData } = data;
    this.setState({
      checkedValue,
      groupData,
    });
  };


  fetchNewsById = channelList => {
    const { dispatch, formData } = this.props;
    const that = this;

    dispatch({
      type: 'createIndependentCourse/fetchNewsById',
      params: {
        id: this.newsId,
        appCode: getAppCode()
      },
    }).then(details => {
      const { newsSelectDO, newsInfoExtend, chapterInfoVOList, labelList } = details;
      const { selectId = '', isEmployee, isStudent, student } = newsSelectDO || {};
      const { classType, isTiming, needPush, timingPushTime } = newsInfoExtend || {}

      const chapterInfoData = [{
        id: chapterInfoVOList[0]?.chapterMaterial[0].materialId,
        title: chapterInfoVOList[0]?.chapterMaterial[0].materialName,
      }]

      const arr = [];
      labelList.forEach(item => {
        arr.push({
          labelName: item.label,
          labelId: item.id,
        });
      });

      dispatch({
        type: 'courseManage/fetchLabelWithGroup',
        params: { appCode: getAppCode() },
      }).then(labelData => {
        labelData.forEach(item => {
          item.list.forEach(tag => {
            details.labelList.forEach(checkedValue => {
              if (checkedValue.id === tag.labelId) {
                tag.checked = true;
              }
            });
          });
        });
        this.setState({
          spinning: false,
          checkedValue: arr,
          groupData: labelData,
        });
      });


      dispatch({
        type: 'createIndependentCourse/saveState',
        payload: {
          formData: {
            ...formData,
            title: details.title,
            coverPicFileId: details.coverPicFileId,
            selectId,
            isEmployee,
            isStudent,
            classType,
            needPush,
            isTiming,
            timingPushTimeString: Number(isTiming) === 0 ? moment().add(2, 'hours') : moment(timingPushTime),
          },
          fileList: [
            {
              uid: '-1',
              name: 'image.png',
              status: 'done',
              url: details.coverPicUrl1,
            },
          ],
          defaultDataChannelId: getDefaultData(channelList, details.channelId),
          student: student?.split(','),
          materialIdList: chapterInfoData,
          checkedValue: arr,
        },
      });

      if (student.split(',').length === allIdList.length) {
        that.setState({
          checkAll: true,
        })
      }

    })
  }

  fetchChannelList = () => {
    const { dispatch } = this.props;
    this.setState({ spinning: true });
    dispatch({
      type: 'createIndependentCourse/fetchChannelList',
      params: { appCode: getAppCode(), iseditnews: 1 },
    })
      .then(res => {
        this.setState({ channelList: convertData(res || []), spinning: false });

        if (this.newsId) {
          this.fetchNewsById(res || []);
        }

      })
      .catch(() => {
        this.setState({ spinning: false });
      });
  };

  handleCancel = () => {
    this.setState({
      previewImage: '',
      previewVisible: false,
    });
  };

  changeTab = activeKey => {
    this.setState({ activeKey });
  };


  handleChange = info => {
    let { fileList } = info;
    fileList = fileList.slice(-1);
    fileList = fileList.map(file => {
      if (file.response) {
        if (file.response.code !== 0) {
          message.info(file.response.msg);
        }
      }
      return file;
    });
    fileList = fileList.filter(file => {
      if (file.response) {
        if (file.response.code !== 0) {
          message.info(file.response.msg);
        }
        return file.response.code === 0;
      }
      return true;
    });
    const { dispatch, formData } = this.props;
    dispatch({
      type: 'createIndependentCourse/saveState',
      payload: {
        fileList,
        formData: {
          ...formData,
          coverPicFileId: fileList[0] &&
            fileList[0].response &&
            fileList[0].response.data &&
            fileList[0].response.data.fileId,
          lxPicUrl:
            fileList[0] &&
            fileList[0].response &&
            fileList[0].response.data &&
            fileList[0].response.data.lxPicUrl,

        },
      },
    });
  };

  nextStep = () => {
    const { activeKey } = this.state;
    this.setState({ activeKey: `${Number(activeKey) + 1}` });
  };

  preStep = () => {
    const { activeKey } = this.state;
    this.setState({ activeKey: `${Number(activeKey) - 1}` });
  };

  handleOk = () => {
    const { form, dispatch, formData, student } = this.props;
    const { validateFields } = form;

    const { isEmployee, isStudent } = formData;

    validateFields(err => {
      if (!err && formData.coverPicFileId) {

        if (!isEmployee && !isStudent) {
          message.error('请选择发布对象');
          return;
        }
        if (isStudent && student.length === 0) {
          message.error('请选择学生学段');
          return;
        }

        dispatch({
          type: 'createIndependentCourse/saveState',
          payload: { publishModalVisible: true },
        });
      } else {
        message.error('信息填写页必填项未填写完整');
      }
    });

  };


  saveArticle = () => {
    const { form, formData, materialIdList, student, dispatch } = this.props;
    const { getFieldsValue } = form;
    const values = getFieldsValue();
    const { selectId, channelId, timingPushTimeString } = values;
    const { isStudent, isEmployee } = formData;
    const { checkedValue } = this.state;


    // const arr = [];
    // checkedValue.forEach(item => {
    //   arr.push({
    //     id: item.labelId,
    //     label: item.labelName,
    //   });
    // });


    const params = {
      ...formData,
      ...values,
      id: this.newsId,
      content: '',
      channelId: channelId[channelId.length - 1],
      coverPicFileId: formData.coverPicFileId,
      lxPicUrl: formData.lxPicUrl,
      chapterList: [{
        chapterName: '',
        chapterMaterial: [{
          materialId: materialIdList[0].id,
          materialName: materialIdList[0].title
        }]
      }],
      timingPushTimeString: moment(timingPushTimeString).format('YYYY-MM-DD HH:mm'),
      selectSetting: {
        selectId: selectId || formData.selectId,
        isStudent: isStudent ? 1 : 0,
        isEmployee: isEmployee ? 1 : 0,
        student: student.toString(),
      },
      labelList: checkedValue,
    };

    this.setState({ spinning: true });
    dispatch({
      type: 'createIndependentCourse/fetchSaveOrUpdate',
      params,
    }).then(() => {
      this.setState({ spinning: false });
      message.success('保存成功');
      router.goBack();
    })
      .catch(() => {
        this.setState({ spinning: false });
      });
  };


  renderTabTitle = (activeKey, title, index) => {
    return (
      <span>
        <i
          className={
            activeKey === index ? 'common-icon-style active-style' : 'common-icon-style icon-style'
          }
        >
          {index}
        </i>
        {title}
      </span>
    );
  };


  renderFooter = () => {
    const { activeKey } = this.state;

    return {
      states: !0,
      demFooter: (
        <>
          {["2", "3"].indexOf(activeKey) > -1 && (
            <Button type="default" onClick={this.preStep}>
              上一步
            </Button>
          )}
          {["1", "2"].indexOf(activeKey) > -1 && (
            <Button type="primary" onClick={this.nextStep}>
              下一步
            </Button>
          )}
          {activeKey === "3" && (
            <Button
              type="primary"
              onClick={this.handleOk}
            >
              发布
            </Button>
          )}
        </>
      )
    };
  };

  chooseCourse = (chooseCourseId, chooseCourseData) => {

    const { dispatch, form, formData, fileList } = this.props;
    const { setFieldsValue } = form;

    dispatch({
      type: 'createIndependentCourse/saveState',
      payload: {
        materialIdList: chooseCourseData,
      },
    });

    if (!fileList?.length) {
      dispatch({
        type: 'createIndependentCourse/saveState',
        payload: {
          formData: {
            ...formData,
            coverPicFileId: chooseCourseData[0]?.coverPicFileId,
          },
          fileList: [
            {
              uid: '-1',
              name: 'image.png',
              status: 'done',
              url: chooseCourseData[0]?.coverPicUrl1,
            },
          ],
        },
      });

    }

    setFieldsValue({
      materialIdList: chooseCourseId,
    });
  }

  renderInformation = () => {
    const that = this;
    const {
      previewImage,
      previewVisible,
      channelList,
      checkedValue,
      groupData
    } = this.state;
    const { form, dispatch, fileList, formData, materialIdList, defaultDataChannelId } = this.props;
    const { title, classType, newsType } = formData;
    const { getFieldsValue, getFieldDecorator } = form;

    const formItemLayout = {
      labelCol: { span: 3 },
      wrapperCol: { span: 20 },
    };

    const uploadButton = (
      <div>
        <Icon type="plus" />
        <div className="ant-upload-text">上传封面</div>
      </div>
    );
    const props = {
      action: `${api.url}/web/v3/news/file/upload`,
      data: { newsType },
      withCredentials: true,
      name: 'file',
      listType: 'picture-card',
      fileList,
      beforeUpload(file) {
        return new Promise((resolve, reject) => {
          const type = ['image/jpeg', 'image/png', 'image/jpg'];
          const isJPG = type.indexOf(file.type) !== -1;
          if (!isJPG) {
            message.error('只能上传jpg/png/jpeg格式图片!');
          }
          const isLt4M = file.size / 1024 / 1024 < 5;
          if (!isLt4M) {
            message.error('图片不能大小超过5MB!');
          }
          if (!isJPG || !isLt4M) {
            // eslint-disable-next-line prefer-promise-reject-errors
            return reject(false);
          }
          return resolve(true);
        });
      },
      onPreview(file) {
        that.setState({
          previewImage: file.url || file.thumbUrl,
          previewVisible: true,
        });
      },
      onRemove() {
        dispatch({
          type: 'createIndependentCourse/saveState',
          payload: { fileList: [] },
        });
      },
    };

    const titleProps = {
      form,
      value: title,
      label: '开课主题',
      keyName: 'title',
      maxLength: 100,
      suffix: `${(getFieldsValue().title && getFieldsValue().title.length) || 0}/100`,
    };

    const channelIdProps = {
      form,
      value: defaultDataChannelId,
      label: '栏目选择',
      keyName: 'channelId',
      isRequired: true,
      optionsData: channelList,
    };

    const radioProps = {
      RadioGroupOptions: [{ label: '选修课', value: '0' }, { label: '必修课', value: '1' }],
      label: "课程类型",
      isRequired: false,
      keyName: "classType",
      value: `${classType}` || '0',
      form
    };

    return (
      <>
        <FormTitle {...titleProps} />
        <Item
          className="course-content"
          label='课程内容'
        >
          {getFieldDecorator('materialIdList', {
            initialValue: materialIdList,
            rules: [{ required: true, message: '请选择课程内容' }],
          })(<CourseContentModal chooseCourse={this.chooseCourse} checkedData={materialIdList} />)}
        </Item>
        <Form.Item label="课程封面" {...formItemLayout} className="necessary imgBox">
          {getFieldDecorator(`coverPicFileId`)(
            <>
              <Upload {...props} onChange={this.handleChange}>
                {fileList.length >= 1 ? null : uploadButton}
              </Upload>
              <Modal
                centered
                width={950}
                visible={previewVisible}
                footer={null}
                onCancel={this.handleCancel}
              >
                <div
                  style={{
                    backgroundImage: `url(${previewImage})`,
                    width: 900,
                    height: 383,
                    backgroundPosition: '50% 50%',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                  }}
                />
                {/* <img alt="example" style={{ width: '100%' }} src={previewImage} /> */}
              </Modal>
            </>
          )}
          <div className="upload-img-tips">说明: 请上传230px*154px的图片，未上传则默认同步素材封面</div>
        </Form.Item>
        <FormCascader {...channelIdProps} />
        <Form.Item label="关联标签" {...formItemLayout}>
          {getFieldDecorator(`labelList`, {
            initialValue: checkedValue,
            valuePropName: 'checkedValue',
            trigger: 'handleOk',
            // eslint-disable-next-line no-shadow
            getValueFromEvent: ({ checkedValue = [] } = {}) => {
              return checkedValue;
            },
            rules: [
              {
                required: false,
                message: '请选择标签',
              },
            ],
          })(
            <SelectTagModal
              checkedValue={checkedValue}
              groupData={groupData}
              handleOk={this.handleSaveLabelOk}
            />
          )}
          <div className="select-label-tips">说明: 最多可关联10个标签</div>
        </Form.Item>
        <div style={{ 'margin-top': '-20px' }}>
          <FormRadioGroup {...radioProps} />
        </div>
      </>
    );
  };

  renderAttribute = () => {
    const { form, formData } = this.props;
    const {
      needPush = '1',

    } = formData;

    const needRemindProps = {
      form,
      value: needPush,
      label: '消息提醒',
      keyName: 'needPush',
      isRequired: false,
      RadioGroupOptions: [
        { label: '是', value: '1' },
        { label: '否', value: '0' },
      ],
      tips: '说明: 对本次发布的对象推送消息提醒',
    };

    return (
      <>
        {/* 消息提醒 */}
        <FormRadioGroup {...needRemindProps} />
      </>
    );
  };

  chooseStudent = checkedValues => {
    const { dispatch } = this.props;
    dispatch({
      type: 'createIndependentCourse/saveState',
      payload: { student: checkedValues },
    });

    this.setState({
      checkAll: checkedValues.length === allIdList.length,
    });
  }


  onCheckAllChange = e => {
    const { dispatch } = this.props;
    dispatch({
      type: 'createIndependentCourse/saveState',
      payload: {
        student: e.target.checked ? allIdList : []
      },
    });

    this.setState({
      checkAll: e.target.checked,
    });
  };

  render() {
    const {
      spinning,
      activeKey,
      checkAll,

    } = this.state;
    const { form, formData, currentUser, student, dispatch } = this.props;
    const { selectId = '', isStudent = 0, isEmployee = 0 } = formData;
    const { orgType } = currentUser || {};
    const { getFieldsValue } = form;
    const customerFormItemLayout = {
      labelCol: { span: 3 },
      wrapperCol: { span: 20 },
    };
    const formItemLayout = {
      labelCol: { span: 3 },
      wrapperCol: { span: 20 },
    };

    const selectUserProps = {
      form,
      value: selectId,
      appName: '宣传管理',
      appId: 1,
      orgType,
      label: '组织选择',
      message: '选择需要发送的组织',
      keyName: 'selectId',
      isRequired: true,
      selectProps: {
        multiple: true,
        selectType: 'dept',
        strictOrgRel: false,
        showTabList: ['orgRel'],
        dialogProps: {
          title: '选择组织',
        },
        searchPlaceholder: '搜索名称',
        selectSignature: selectId,
        isSaveSelectSignature: true,
        requestParams: {
          strictUser: true,
          selectTypeList: ['org_rel'],
        },
      },
    };

    const isStudentProps = {
      form,
      value: isStudent === 1,
      label: "学生",
      keyName: "isStudent",
      isRequired: false,
      onChange: e => {
        dispatch({
          type: 'createIndependentCourse/saveState',
          payload: {
            formData: {
              ...formData,
              isStudent: Number(e.target.checked)
            },
          },
        });
      },
    };

    const isEmployeeProps = {
      form,
      value: isEmployee === 1,
      label: "教职工",
      keyName: "isEmployee",
      isRequired: false,
      onChange: e => {
        dispatch({
          type: 'createIndependentCourse/saveState',
          payload: {
            formData: {
              ...formData,
              isEmployee: Number(e.target.checked)
            },
          },
        });
      },
    };

    return (
      <Container breStates={!0} version={2} defaultPadding footerParams={this.renderFooter()}>
        <div className={styles['microsite-createIndependentCourse-spin']}>
          <Spin spinning={spinning}>
            <div className={styles.root}>
              <FormCreate customerFormItemLayout={customerFormItemLayout}>
                <Tabs defaultActiveKey="1" activeKey={activeKey} onChange={this.changeTab}>
                  <TabPane tab={this.renderTabTitle(activeKey, '开课内容', '1')} key="1">
                    {this.renderInformation()}
                  </TabPane>
                  <TabPane tab={this.renderTabTitle(activeKey, '对象选择', '2')} key="2">
                    <SelectUserVersion4 {...selectUserProps} />
                    <Form.Item label="对象" {...formItemLayout} className="send-user">
                      <div className='people-type-select'>
                        <FormCheckbox {...isStudentProps} />
                      </div>
                      <div className='class-group'>
                        <div className='title'>学段</div>
                        <div className='checkbox-wrap'>
                          <Checkbox
                            onChange={this.onCheckAllChange}
                            checked={checkAll}
                            disabled={isStudent !== 1}
                          >
                            全选
                          </Checkbox>
                          <Checkbox.Group onChange={this.chooseStudent} value={student}>
                            <div>
                              {
                                kindergartenClass.map(item => {
                                  return <Checkbox value={item.key} disabled={isStudent !== 1}>{item.name}</Checkbox>
                                })
                              }
                            </div>
                            <div>
                              {
                                primarySchoolClass.map(item => {
                                  return <Checkbox value={item.key} disabled={isStudent !== 1}>{item.name}</Checkbox>
                                })
                              }
                            </div>
                            <div>
                              {
                                middleSchoolClass.map(item => {
                                  return <Checkbox value={item.key} disabled={isStudent !== 1}>{item.name}</Checkbox>
                                })
                              }
                            </div>
                          </Checkbox.Group>
                        </div>
                      </div>
                      <div className='people-type-select'>
                        <FormCheckbox {...isEmployeeProps} />
                      </div>
                    </Form.Item>
                  </TabPane>
                  <TabPane tab={this.renderTabTitle(activeKey, '属性设置', '3')} key="3">
                    {this.renderAttribute()}
                  </TabPane>
                </Tabs>
              </FormCreate>
            </div>
          </Spin>
          <PublishModal
            values={{ ...formData, ...getFieldsValue() }}
            handleOk={this.saveArticle}
          />
        </div>
      </Container>
    );
  }
}
export default Edit;
